import { getDefaultAsyncWrapperObj } from "@ane/core/lib/models";
import { loadSubscriberDisplayNamesByEntitiesEpicReducer } from "./epics.js";
const subscriberDisplayNamesByEntitiesDefaultReducerState = {
  items: getDefaultAsyncWrapperObj()
};
const subscriberDisplayNamesByEntitiesReducer = (state = subscriberDisplayNamesByEntitiesDefaultReducerState, action) => {
  state = loadSubscriberDisplayNamesByEntitiesEpicReducer.reduxChange(state, action);
  return state;
};
const LoadSubscriberDisplayNamesByEntitiesReducersMapObject = {
  subscribers: subscriberDisplayNamesByEntitiesReducer
};
export {
  LoadSubscriberDisplayNamesByEntitiesReducersMapObject,
  LoadSubscriberDisplayNamesByEntitiesReducersMapObject as default,
  subscriberDisplayNamesByEntitiesDefaultReducerState,
  subscriberDisplayNamesByEntitiesReducer
};
//# sourceMappingURL=duck.js.map
